import { render } from "./WorktimeComponent.vue?vue&type=template&id=2c047c4b"
import script from "./WorktimeComponent.vue?vue&type=script&lang=js"
export * from "./WorktimeComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__